import { useEffect, useState } from 'react';

/**
 * The previous value until `delay` has passed without a change. Debouncing the value rather than the request
 * keeps the input instant: the field updates on every keystroke, only the query waits for the typing to stop.
 */
export function useDebouncedValue<T>(value: T, delay = 300): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = window.setTimeout(() => setDebounced(value), delay);
    return () => window.clearTimeout(timer);
  }, [value, delay]);

  return debounced;
}
